export default function HaileyChatBotIco() {
  return (
    <svg
      width="17"
      height="20"
      viewBox="0 0 17 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.1287 8.73283C11.8701 10.2391 13.0793 11.4639 14.5748 12.2234L15.4672 12.6766C15.7922 12.8417 15.7922 13.306 15.4672 13.4711L14.5748 13.9243C13.0793 14.6838 11.8701 15.9086 11.1287 17.4149L10.6809 18.3248C10.5177 18.6565 10.0447 18.6565 9.88144 18.3248L9.43361 17.4149C8.69228 15.9086 7.4831 14.6838 5.9876 13.9243L5.09518 13.4711C4.77012 13.306 4.77012 12.8417 5.09518 12.6766L5.9876 12.2234C7.4831 11.4639 8.69229 10.2391 9.43362 8.73284L9.88145 7.82294C10.0447 7.49122 10.5177 7.49122 10.6809 7.82294L11.1287 8.73283Z"
        fill="#7F56D9"
      />
      <path
        d="M4.31017 3.78433C4.77898 4.73686 5.54364 5.51141 6.48937 5.9917L7.05372 6.27831C7.25928 6.38271 7.25928 6.67633 7.05372 6.78073L6.48937 7.06734C5.54364 7.54763 4.77898 8.32218 4.31017 9.2747L4.02697 9.85011C3.92373 10.0599 3.62464 10.0599 3.5214 9.85011L3.2382 9.2747C2.76939 8.32218 2.00473 7.54764 1.05899 7.06734L0.494642 6.78073C0.289083 6.67633 0.289083 6.38271 0.494642 6.27831L1.05899 5.9917C2.00473 5.51141 2.76939 4.73686 3.2382 3.78434L3.5214 3.20893C3.62464 2.99916 3.92373 2.99916 4.02698 3.20893L4.31017 3.78433Z"
        fill="#7F56D9"
      />
      <path
        d="M11.1661 0.765696C11.501 1.43542 12.0471 1.98001 12.7227 2.3177L12.975 2.44383C13.1827 2.54766 13.1827 2.84403 12.975 2.94786L12.7227 3.07399C12.0471 3.41169 11.501 3.95627 11.1661 4.626L11.0353 4.88769C10.9314 5.09535 10.6351 5.09535 10.5312 4.88769L10.4004 4.626C10.0655 3.95627 9.51935 3.41169 8.84383 3.07399L8.59152 2.94786C8.38383 2.84403 8.38383 2.54766 8.59152 2.44384L8.84383 2.3177C9.51935 1.98001 10.0655 1.43542 10.4004 0.765697L10.5312 0.504007C10.6351 0.296345 10.9314 0.296345 11.0353 0.504007L11.1661 0.765696Z"
        fill="#7F56D9"
      />
    </svg>
  );
}
